export class FormBase<T> {
    value:                          T;
    additionalClasses:              string;
    additionalDirectives:           string;
    controlType:                    string;
    customRegExVal:                 RegExp;
    key:                            string;
    icon:                           boolean;
    iconClasses:                    string;
    inputType:                      string;
    label:                          string;
    minLength:                      number;
    maxLength:                      number;
    required:                       boolean;
    order:                          number;
    showPasswordIcon:               boolean;
    userSubscription:               string;
    validationMessageError:         string;
    matchMessageError:              string;
    addressType:                    string;
    min:                            string;
    max:                            string;
    placeholder:                    string;
    hasCallenderCustomIcon:          boolean;  
    showWarnIcon: boolean;
    showErrorMsg: boolean;
    
    constructor(options: 
    {
        value?:                     T,
        additionalClasses?:         string,
        additionalDirectives?:         string,
        controlType?:               string,
        customRegExVal?:            RegExp,
        key?:                       string,
        icon?:                      boolean,
        iconClasses?:               string,
        inputType?:                  string,
        label?:                     string,
        minLength?:                 number,
        maxLength?:                 number,
        required?:                  boolean,
        order?:                     number,
        showPasswordIcon?:          boolean,
        userSubscription?:          string,
        validationMessageError?:    string,
        matchMessageError?:         string,
        addressType?:               string,
        min?:                       string,
        max?:                       string,
        placeholder?:               string,
        hasCallenderCustomIcon?:    boolean,
        showWarnIcon?:              boolean;
        showErrorMsg?:              boolean;

    } = {}) 
    {
        this.value =                options.value;
        this.additionalClasses =    options.additionalClasses;
        this.additionalDirectives =    options.additionalDirectives;
        this.controlType =          options.controlType || '';
        this.key =                  options.key || '';
        this.icon =                 !!options.icon;
        this.iconClasses =          options.iconClasses || '';
        this.inputType =            options.inputType || '';
        this.label =                options.label || '';
        this.minLength =            options.minLength === undefined ? 0 : options.minLength;
        this.maxLength =            options.maxLength === undefined ? 128 : options.maxLength;
        this.required =             !!options.required;
        this.order =                options.order === undefined ? 1 : options.order;
        this.showPasswordIcon =     !!options.showPasswordIcon;
        this.userSubscription =     options.userSubscription || '';
        this.validationMessageError = options.validationMessageError;
        this.matchMessageError = options.matchMessageError; 
        this.addressType = options.addressType || '';
        this.min =                   options.min || '';
        this.max =                   options.max || '';
        this.placeholder =           options.placeholder || '';
        this.hasCallenderCustomIcon = !!options.hasCallenderCustomIcon;
        this.showWarnIcon = options.showWarnIcon;
        this.showErrorMsg = options.showErrorMsg;
    }
}